export const quizQuestions = {
  es: [
    {
      id: "age_range",
      question: "¿En qué rango de edad te encuentras?",
      options: ["18-29", "30-44", "45-59", "60 o más"],
    },
    {
      id: "energy_level",
      question: "¿Cómo describirías tu energía diaria?",
      options: [
        "Muy baja, me siento agotado/a",
        "Baja, decae a media tarde",
        "Aceptable pero variable",
        "Buena y constante",
      ],
    },
    {
      id: "sleep_quality",
      question: "¿Cómo está tu calidad de sueño?",
      options: [
        "Mala, duermo poco o me despierto",
        "Regular, descanso a medias",
        "Buena la mayoría de las noches",
        "Excelente y reparadora",
      ],
    },
    {
      id: "stress_level",
      question: "¿Cuál es tu nivel de estrés actual?",
      options: ["Bajo", "Moderado", "Alto", "Muy alto / ansiedad frecuente"],
    },
    {
      id: "main_concern",
      question: "¿Cuál es tu principal preocupación de salud hoy?",
      options: [
        "Sistema inmune débil",
        "Digestión / intestino",
        "Mente, memoria y enfoque",
        "Energía y vitalidad",
        "Peso y metabolismo",
        "Huesos / articulaciones",
      ],
    },
    {
      id: "activity_level",
      question: "¿Cómo es tu nivel de actividad física?",
      options: [
        "Sedentario/a",
        "Camino o ejercito 1-2 veces por semana",
        "Activo/a, 3-4 veces por semana",
        "Atlético/a, 5+ veces por semana",
      ],
    },
    {
      id: "diet_quality",
      question: "¿Cómo describirías tu alimentación?",
      options: [
        "Procesada / poco saludable",
        "Mixta, me cuesta ser constante",
        "Balanceada la mayoría del tiempo",
        "Muy limpia y consciente",
      ],
    },
    {
      id: "digestion",
      question: "¿Cómo está tu digestión normalmente?",
      options: [
        "Frecuente inflamación o malestar",
        "Estreñimiento o diarrea ocasional",
        "Buena, sin molestias",
        "Excelente y regular",
      ],
    },
    {
      id: "conditions",
      question: "¿Tienes alguna condición que debamos considerar?",
      options: [
        "Ninguna conocida",
        "Hipertensión",
        "Diabetes / prediabetes",
        "Autoinmune o inflamatoria",
        "Otra",
      ],
    },
    {
      id: "goal",
      question: "¿Cuál es tu meta principal en los próximos 3 meses?",
      options: [
        "Longevidad y prevención",
        "Más energía y vitalidad",
        "Bajar de peso",
        "Mejor rendimiento físico",
        "Claridad mental y enfoque",
        "Mejor sueño y calma",
      ],
    },
  ],
  en: [
    {
      id: "age_range",
      question: "What's your age range?",
      options: ["18-29", "30-44", "45-59", "60+"],
    },
    {
      id: "energy_level",
      question: "How would you describe your daily energy?",
      options: [
        "Very low, I feel exhausted",
        "Low, crashes mid-afternoon",
        "Acceptable but variable",
        "Good and steady",
      ],
    },
    {
      id: "sleep_quality",
      question: "How is your sleep quality?",
      options: [
        "Poor — short or interrupted",
        "Average, partial rest",
        "Good most nights",
        "Excellent and restorative",
      ],
    },
    {
      id: "stress_level",
      question: "What's your current stress level?",
      options: ["Low", "Moderate", "High", "Very high / frequent anxiety"],
    },
    {
      id: "main_concern",
      question: "What's your top health concern today?",
      options: [
        "Weak immune system",
        "Digestion / gut",
        "Mind, memory, focus",
        "Energy and vitality",
        "Weight and metabolism",
        "Bones / joints",
      ],
    },
    {
      id: "activity_level",
      question: "What's your physical activity level?",
      options: [
        "Sedentary",
        "Walking or exercising 1-2x / week",
        "Active, 3-4x / week",
        "Athletic, 5+ times / week",
      ],
    },
    {
      id: "diet_quality",
      question: "How would you describe your diet?",
      options: [
        "Processed / unhealthy",
        "Mixed, hard to stay consistent",
        "Balanced most of the time",
        "Very clean and intentional",
      ],
    },
    {
      id: "digestion",
      question: "How is your digestion typically?",
      options: [
        "Frequent bloating or discomfort",
        "Occasional constipation/diarrhea",
        "Good, no discomfort",
        "Excellent and regular",
      ],
    },
    {
      id: "conditions",
      question: "Any condition we should consider?",
      options: [
        "None known",
        "Hypertension",
        "Diabetes / pre-diabetes",
        "Autoimmune or inflammatory",
        "Other",
      ],
    },
    {
      id: "goal",
      question: "Your main goal in the next 3 months?",
      options: [
        "Longevity and prevention",
        "More energy and vitality",
        "Lose weight",
        "Better physical performance",
        "Mental clarity and focus",
        "Better sleep and calm",
      ],
    },
  ],
};
